import Button from 'components/base/Button';
import { Col, FloatingLabel, Form, Row, Toast, ToastContainer } from 'react-bootstrap';
import { useAuth } from 'providers/AuthProvider'
import { useState, FormEvent } from 'react';
import apiClient, { handleAPIError } from 'helpers/apiService';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import FeedbackForm from './components/FeedbackForm';
import Dropzone from 'components/base/Dropzone';

const AddFeedback = () => {

    const { feedback_type } = useParams();
    const { t } = useTranslation();



    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Feedback'),
            url: '/feedback-dashboard'
        },
        {
            label: feedback_type === 'receive' ? 'Requested Feedbacks' : t('Given Feedbacks'),
            url: feedback_type === 'receive' ? '/feedback-dashboard/received-feedbacks' : '/feedback-dashboard/given-feedbacks'
        },
        {

            label: feedback_type === 'receive' ? t('ReceivedFeedbacks.add_feedback') : t('Given Feedbacks'),
            active: true
        }
    ];


    const navigate = useNavigate();
    const auth = useAuth();

    // State to store the form data from all child components
    const [formData, setFormData] = useState<any>({ 'feedbackForm': '', 'notes': '', 'image': null });
    // State to control Toast messages
    const [show, setShow] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [files, setFiles] = useState<File[]>([]);

    // Function to handle input changes
    const handleNotesInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Function to handle form data update from child components
    const updateFormData = (name: string, data: any) => {
        setFormData({ ...formData, [name]: data });
    };



    const handleSumbit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        //console.log(formData);

        if (feedback_type === null || feedback_type === '') return;

        const form = new FormData();
        form.append('feedbackForm', JSON.stringify(formData['feedbackForm']));
        form.append('notes', formData['notes']);
        // new file(s)
        files.forEach(file => {
            form.append('files', file);
        });

        try {
            const response = await apiClient.post(
                '/v1/feedbacks/' + feedback_type, form,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',

                    }
                }
            );
            setToastMessage(response.data['message'])
            setShow(true);
        } catch (error) {
            console.error('Request failed:', error);
        }

    };

    return (
        <div className="mb-9">
            <div>
                <ToastContainer className="p-3" position='top-center'>
                    <Toast onClose={() => { setShow(false); navigate(-1); }} show={show} delay={3000} autohide>
                        <Toast.Body className=''>{toastMessage}</Toast.Body>
                    </Toast>
                </ToastContainer>
            </div>

            <PageBreadcrumb items={breadcrumbItems} />
            <Form onSubmit={handleSumbit} className='mt-4'>
                <Row >
                    {/* 
                    <Col sm={3} md={3} >
                        <div className="d-flex align-items-end position-relative mb-7">
                            <AvatarUpload src={formData['image'] ? formData['image'] : avatar} size="5xl" onChange={onChangeContactImage} />
                        </div>
                    </Col>
                    */}
                    <Col sm={8} md={8} >
                        <FeedbackForm onUpdate={data => updateFormData('feedbackForm', data)} className="mb-6" feedback_type={feedback_type} />
                    </Col>
                    <Col>
                        <div className="mb-5">
                            <h4 className="mb-3">{t('AddFeedback.add_document')}</h4>
                            <Dropzone single={true}
                                className="mb-3"
                                onFileListUpdate={files => setFiles(files)}
                                accept={{
                                    'image/*': ['.png', '.gif', '.jpeg', '.jpg'],
                                    'application/pdf': ['.pdf'],
                                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
                                }}
                            />
                        </div>
                    </Col>
                </Row><Row>
                    <Col>

                        <h4 className="mb-3">{t('AddFeedback.notes')}</h4>
                        <FloatingLabel
                            controlId="feedback-notes"
                            label=""
                        >
                            <Form.Control
                                as="textarea"
                                style={{ height: '128px' }}
                                type="text"
                                name='notes' value={formData.notes} onChange={handleNotesInputChange} />
                        </FloatingLabel>
                        <div className="text-end">
                            <Button type="submit" variant="primary" className='mt-2'>{feedback_type === 'receive' ? t('AddFeedback.request_feedback') : t('AddFeedback.save_feedback')}</Button>
                        </div>

                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default AddFeedback;
